import { styled } from '@mui/material/styles'
import Sidebar from './Sidebar'
import useLayout from '../../hooks/playground/useLayout'

type PlaygroundLayoutViewType = ReturnType<typeof useLayout>
const LayoutView: React.FC<PlaygroundLayoutViewType> = ({ children }) => {
    return (
        <Root>
            <Container>
                <Sidebar />
                <StyledDivContent>{children}</StyledDivContent>
            </Container>
        </Root>
    )
}

const Layout: React.FC = ({ children }) => {
    const model = useLayout()
    return <LayoutView children={children} {...model} />
}

const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
}))

const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    height: '100%',
}))

const StyledDivContent = styled('div')(({ theme }) => ({
    flexGrow: 1,
    position: 'fixed',
    width: 'calc(100% - 200px)',
    left: '200px',
    height: '100%',
}))

export default Layout
